export default __webpack_public_path__ + "static/media/under-construction.52665b1c.jpg";